import React from 'react'

//* Assets
import wp_assets from 'assets/wordpress.json';
import ICheck from 'assets/icon_check.png';

//* Hooks
import useResponsiveJSX from 'hooks/useResponsiveJSX';

//* Translations
import { TRANSLATIONS } from 'pages/FindYourPhone/utilities';
import { getTranslation } from 'translations';

//* Styles
import styles from './Section3.module.scss';

const Section3 = () => {

    const bp = useResponsiveJSX();

    const LANG = document.documentElement.lang.substring(0, 2).toLowerCase();

  return (
    <section className={`${styles["section3"]} ${bp < 3 ? styles["section3-sm"] : styles["section3-xl"]}`}>
        <img src={wp_assets["find-your-phone"].section3[LANG]} alt="" className={`${styles["section3-img"]} ${ bp < 3 ? styles["section3-img-sm"] : styles["section3-img-xl"]}`} />
        <div className={`${styles["text-content"]} ${bp < 3 ? styles["text-content-sm"] : styles["text-content-xl"]}`}>
            <h2 className={styles['section-title']}>{getTranslation(TRANSLATIONS, LANG, "section3-title")}</h2>
            <div className={styles["icon-text"]}>
                <img src={ICheck} alt="icon-check" className={styles["icon"]}/>
                <p className={styles["text"]}>{getTranslation(TRANSLATIONS, LANG, "section3-free_shipping")}</p>
            </div>
            <div className={styles["icon-text"]}>
                <img src={ICheck} alt="icon-check" className={styles["icon"]}/>
                <p className={styles["text"]}>{getTranslation(TRANSLATIONS, LANG, "section3-warranty")}</p>
            </div>
            <div className={styles["icon-text"]}>
                <img src={ICheck} alt="icon-check" className={styles["icon"]}/>
                <p className={styles["text"]}>{getTranslation(TRANSLATIONS, LANG, "section3-guarantee")}</p>
            </div>
        </div>
    </section>
  )
}

export default Section3